export default __webpack_public_path__ + "static/media/A.d63ff203.svg";